import { render } from "./ExampleQueries.vue?vue&type=template&id=480641f6&scoped=true&ts=true"
import script from "./ExampleQueries.vue?vue&type=script&lang=ts"
export * from "./ExampleQueries.vue?vue&type=script&lang=ts"

import "./ExampleQueries.vue?vue&type=style&index=0&id=480641f6&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-480641f6"]])

export default __exports__